/* Swipe JS Module for swipe events with minimal bugs, this fixes the ff.
 *
 * 1. [General] disabled vertical swiping
 * 2. [General] sometimes not responsive
 * 
 * */
$(function() {
  $(".swiper-wrapper").swipe( { swipeLeft:swipe1, swipeRight:swipe2, allowPageScroll:"auto"} );
  
  //Swipe Left Handler
  function swipe1(event, direction, distance, duration, fingerCount) {

      // gets the device width and convert it into integer
      var transformValue = parseInt($(window).width(), 10);

      // specify the slide positions and manually change their classes once swipe to the left 
      $('.swiper-slide[data-media-position="1"]').removeClass('swiper-slide-active').addClass('swiper-slide-prev');
      $('.swiper-slide[data-media-position="2"]').removeClass('swiper-slide-next').addClass('swiper-slide-active');
      $('.swiper-slide[data-media-position="3"]').addClass('swiper-slide-next');

      // changes the currently active pagination bullet 
      $('.swiper-pagination-bullet[aria-label="Go to slide 1"]').removeClass('swiper-pagination-bullet-active').addClass('swiper-pagination-bullet-not-active');
      $('.swiper-pagination-bullet[aria-label="Go to slide 2"]').removeClass('swiper-pagination-bullet-not-active').addClass('swiper-pagination-bullet-active');

      // indicates the slider ID where we will get the necessary values such as the slide width and margin right
      var rand_swiper = $(".swiper-wrapper").get(14).id;

      // check if the device width size is even or odd
      if (transformValue % 2 == 0) {
        // specify the reference element
        var slideWidth = document.querySelector('#'+rand_swiper+' > div.swiper-slide.swiper-slide-active'); 

        // calculate the slide distance necessary once swiped to the left
        var slide_value = parseInt(slideWidth.offsetWidth) + parseInt(slideWidth.style.marginRight, 10);

      } else {
        // specify the reference element
        var slideWidth = document.querySelector('#'+rand_swiper+' > div.swiper-slide.swiper-slide-active'); 

        // calculate the slide distance necessary once swiped to the left
        var slide_value = parseInt(parseInt(slideWidth.offsetWidth) + parseInt(slideWidth.style.marginRight, 10)) - parseInt(0.5);
      }
      
      // manually changes the slide distance of the slide once swiped to the left
      $(".swiper-wrapper").css('transform', 'translate3d(-'+slide_value+'px, 0px, 0px)');
  }

  //Swipe Right Handler
  function swipe2(event, direction, distance, duration, fingerCount) {

    // specify the slide positions and manually change their classes once swiped to the right
    $('.swiper-slide[data-media-position="3"]').removeClass('swiper-slide-next');
    $('.swiper-slide[data-media-position="2"]').removeClass('swiper-slide-active').addClass('swiper-slide-next');
    $('.swiper-slide[data-media-position="1"]').removeClass('swiper-slide-active').addClass('swiper-slide-prev');

    // changes the currently active pagination bullet once swiped to the right
    $('.swiper-pagination-bullet[aria-label="Go to slide 2"]').removeClass('swiper-pagination-bullet-active').addClass('swiper-pagination-bullet-not-active');
    $('.swiper-pagination-bullet[aria-label="Go to slide 1"]').removeClass('swiper-pagination-bullet-not-active').addClass('swiper-pagination-bullet-active');
    
    // default slide distance once swiped to the right
    $(".swiper-wrapper").css('transform', 'translate3d(0px, 0px, 0px)');

  }
});

$(document).on('click', '.swiper-Thigh .swiper-pagination-bullet:not(.init)',function() {
$('.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)').addClass('init');
setTimeout(function(){
  $('.swiper-Rise .swiper-pagination-bullet.init:not(.swiper-pagination-bullet-active)').click();
  $('.swiper-Leg .swiper-pagination-bullet.init:not(.swiper-pagination-bullet-active)').click();
  $('.swiper-pagination-bullet').removeClass('init');
}, 200);
});
$(document).on('click', '.swiper-Rise .swiper-pagination-bullet:not(.init)',function() {
$('.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)').addClass('init');
setTimeout(function(){
  $('.swiper-Thigh .swiper-pagination-bullet.init:not(.swiper-pagination-bullet-active)').click();
  $('.swiper-Leg .swiper-pagination-bullet.init:not(.swiper-pagination-bullet-active)').click();
  $('.swiper-pagination-bullet').removeClass('init');
}, 200);
});
$(document).on('click', '.swiper-Leg .swiper-pagination-bullet:not(.init)',function() {
$('.swiper-pagination-bullet:not(.swiper-pagination-bullet-active)').addClass('init');
setTimeout(function(){
  $('.swiper-Rise .swiper-pagination-bullet.init:not(.swiper-pagination-bullet-active)').click();
  $('.swiper-Thigh .swiper-pagination-bullet.init:not(.swiper-pagination-bullet-active)').click();
  $('.swiper-pagination-bullet').removeClass('init');
}, 200);
});